<template>
    <div class="two-side">
        <div class="small-card pointer" @click="goTo">
            <div class="small-card-img">
                <img :src="image ? image : '/assets/images/icons/image.png'">
            </div>
            <div class="small-card-desc">
                <div class="small-card-desc-date">{{ formatDate() }}</div>
                <div class="small-card-desc-title">
                    <a :href="url" target="_blank"><b>{{title}}</b></a>
                </div>
                 <div class="small-card-desc-title">
                    <a >{{narasumber}}</a>
                </div>
                <div class="small-card-desc-author" v-if="author">
                    <div class="small-card-desc-author-name">
                        {{author}}
                    </div>
                    <div class="small-card-desc-author-view">
                         
                    </div>
                </div>
                <div v-if="link" class="small-card-desc-link">
                    Video Dokumentasi : {{link}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import {nFormatter} from '../../NumberFormatter.js'

export default {
    props: ['id','title', 'image', 'narasumber','tanggal','author','view', 'link', 'url'],
    methods: {
        formatDate() {
           
           
            return moment(this.tanggal, "YYYY-MM-DD").locale('id').format("D MMMM YYYY");
           
        },
        
        
        goTo() {
            const link = this.link || this.url
            const response = this.getProtocol(link)
            if(response !== '') {
                window.open(link, '_blank');
            } else {
                window.open(`http://${link}`, '_blank');
            }
        },
        getProtocol(str) {
            try {
                var u = new URL(str);
                return u.protocol.slice(0, -1);
            } catch (e) {
                return '';
            }
        }
    }
}
</script>
<style scoped>
.small-card {
    align-items: center;
    margin-bottom: 25px;
    display: flex;
}
.small-card-img {
    width: 120px;
    height: 120px;
    margin-right: 10px;
}
.small-card-img img {
    border-radius: 8px;
    width: 120px;
    height: 120px;
    object-fit: cover;
}
.small-card-desc-date {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 15px;
    color: #828282;
}
.small-card-desc-title {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    color: #333333;
}
.small-card-desc-title a {
    color: #333333;
    font-size: 14px;
}
.small-card-desc-title a:hover {
    text-decoration: none;
}
.small-card-desc-author {
    color: #BDBDBD;
}
.small-card-desc-author-view i {
    display: block;
    margin-right: 5px;
    width: 15px;
    margin-top: 0;
}
.small-card-desc-author-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 11px;
}
.small-card-desc-author-name {
    font-family: "Poppins", sans-serif;
    font-style: italic;
    font-weight: normal;
    font-size: 11px;
    line-height: 15px;
}
.small-card-desc-link {
    font-family: "Poppins", sans-serif;
    font-style: italic;
    font-weight: normal;
    font-size: 10px;
    line-height: 15px;
    color: #EB5757;
}
.two-side{
    float: left;
    margin: 0px 50px 0px 0px;
}
</style>
